import { useToast } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AssignmentRoute } from './AssignmentRoute';
import {
  errorToastConfig,
  warnToastConfig,
} from 'packages/common-frontend/constants';
import { useSimpleConfirm } from 'packages/common-frontend/hooks/useSimpleConfirm';
import { useDataMetadataContext } from 'valleyBank/domains/page/hooks/DataMetadataContext';
import { useUserRoleTypePermissionsContext } from 'valleyBank/domains/page/hooks/useUserRoleTypePermissions';
import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';

export const AssignmentRouter = () => {
  // !TODO @eldarshamukhamedov react-router@6: This needs to be replaced with unstable_usePrompt as
  // soon as we switch to a data router.
  useSimpleConfirm({
    when: true,
    message:
      'Are you sure you want to leave this page? Any changes not submitted to the queue will be lost.',
  });
  const { permissions } = useUserRoleTypePermissionsContext();
  const { dashboardMode } = useDataMetadataContext();
  const navigate = useNavigate();
  const toast = useToast();

  if (dashboardMode !== 'current') {
    toast({
      ...warnToastConfig,
      id: 'assignment-only-current-mode',
      title: 'Assignment only availble in "current" mode.',
    });
    navigate('/');
  }

  if (!permissions.assignmentQueueRead) {
    toast({
      ...errorToastConfig,
      id: 'unauthorized-assignment-rate',
      title: 'Your user role does not allow access to Assignments',
    });
    navigate('/');
  }

  return (
    <ValleyBankTemplate>
      <AssignmentRoute />
    </ValleyBankTemplate>
  );
};
